import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRyanairComponent } from './simple-icons-ryanair.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRyanairComponent ],
    exports:      [ SimpleIconsRyanairComponent ],
    bootstrap:    []
})
export class SimpleIconsRyanairModule {}
